/* Working Capital Calculator Logic — Math, Charts & CSV Export */

let wcDonutChart = null;
let wcGrowthChart = null;

function getWcInputs() {
  const getVal = (id, def = 0) => {
    const el = document.getElementById(id);
    if (!el) return def;
    const v = +el.value;
    return isNaN(v) ? def : v;
  };

  return {
    cash: getVal('wcCash', 500000),
    ar: getVal('wcAr', 1000000),
    inv: getVal('wcInv', 800000),
    otherCa: getVal('wcOtherCa', 200000),
    ap: getVal('wcAp', 700000),
    stLoans: getVal('wcStLoans', 400000),
    otherCl: getVal('wcOtherCl', 150000),
  };
}

function updateWcUrlParams(params) {
  try {
    const url = new URL(window.location);
    url.searchParams.set('cash', params.cash);
    url.searchParams.set('ar', params.ar);
    url.searchParams.set('inv', params.inv);
    url.searchParams.set('otherCa', params.otherCa);
    url.searchParams.set('ap', params.ap);
    url.searchParams.set('stLoans', params.stLoans);
    url.searchParams.set('otherCl', params.otherCl);
    window.history.replaceState({}, '', url);
  } catch (e) {}
}

function parseWcUrlParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const getNum = (key) => {
    const val = searchParams.get(key);
    return val !== null ? +val : null;
  };

  return {
    cash: getNum('cash'),
    ar: getNum('ar'),
    inv: getNum('inv'),
    otherCa: getNum('otherCa'),
    ap: getNum('ap'),
    stLoans: getNum('stLoans'),
    otherCl: getNum('otherCl'),
  };
}

function calculateWc(params) {
  const { cash, ar, inv, otherCa, ap, stLoans, otherCl } = params;

  const totalCa = cash + ar + inv + otherCa;
  const totalCl = ap + stLoans + otherCl;
  const nwc = totalCa - totalCl;

  const currentRatio = totalCl > 0 ? totalCa / totalCl : 0;
  const quickAssets = cash + ar + otherCa;
  const quickRatio = totalCl > 0 ? quickAssets / totalCl : 0;

  const items = [
    { cat: 'Current Assets', name: 'Cash & Bank Balances', value: cash, share: totalCa > 0 ? (cash / totalCa) * 100 : 0 },
    { cat: 'Current Assets', name: 'Accounts Receivable (Debtors)', value: ar, share: totalCa > 0 ? (ar / totalCa) * 100 : 0 },
    { cat: 'Current Assets', name: 'Inventory & Stock', value: inv, share: totalCa > 0 ? (inv / totalCa) * 100 : 0 },
    { cat: 'Current Assets', name: 'Other Current Assets', value: otherCa, share: totalCa > 0 ? (otherCa / totalCa) * 100 : 0 },
    { cat: 'Current Liabilities', name: 'Accounts Payable (Creditors)', value: ap, share: totalCl > 0 ? (ap / totalCl) * 100 : 0 },
    { cat: 'Current Liabilities', name: 'Short-term Loans & Overdrafts', value: stLoans, share: totalCl > 0 ? (stLoans / totalCl) * 100 : 0 },
    { cat: 'Current Liabilities', name: 'Other Current Liabilities', value: otherCl, share: totalCl > 0 ? (otherCl / totalCl) * 100 : 0 },
  ];

  return {
    cash: Math.round(cash),
    ar: Math.round(ar),
    inv: Math.round(inv),
    otherCa: Math.round(otherCa),
    ap: Math.round(ap),
    stLoans: Math.round(stLoans),
    otherCl: Math.round(otherCl),
    totalCa: Math.round(totalCa),
    totalCl: Math.round(totalCl),
    nwc: Math.round(nwc),
    quickAssets: Math.round(quickAssets),
    currentRatio: +currentRatio.toFixed(2),
    quickRatio: +quickRatio.toFixed(2),
    items,
  };
}

function updateDisplays(params) {
  const setTxt = (id, txt) => {
    const el = document.getElementById(id);
    if (el) el.textContent = txt;
  };

  setTxt('wcCashDisplay', fmt(params.cash));
  setTxt('wcArDisplay', fmt(params.ar));
  setTxt('wcInvDisplay', fmt(params.inv));
  setTxt('wcOtherCaDisplay', fmt(params.otherCa));
  setTxt('wcApDisplay', fmt(params.ap));
  setTxt('wcStLoansDisplay', fmt(params.stLoans));
  setTxt('wcOtherClDisplay', fmt(params.otherCl));
}

function renderWcResults(result, params) {
  const setTxt = (id, txt) => {
    const el = document.getElementById(id);
    if (el) el.textContent = txt;
  };

  const statusStr = result.currentRatio >= 1.5 ? 'Strong Liquidity Position' : result.currentRatio >= 1.0 ? 'Moderate Short-Term Liquidity' : 'Working Capital Deficit (High Risk)';
  setTxt('wcVerdictHeadline', `NWC: ${fmt(result.nwc)} | ${statusStr}`);
  setTxt('wcVerdictDetail', `Your business maintains ${fmt(result.totalCa)} in current assets against ${fmt(result.totalCl)} in current liabilities, yielding a current ratio of ${result.currentRatio}x.`);

  setTxt('wcCurrentRatioStatValue', `${result.currentRatio}x`);
  setTxt('wcQuickRatioStatValue', `${result.quickRatio}x`);
  setTxt('wcTotalCaMetricValue', fmt(result.totalCa));
  setTxt('wcTotalClMetricValue', fmt(result.totalCl));
  setTxt('wcNwcMetricValue', fmt(result.nwc));

  renderTable(result.items);

  try {
    if (typeof Chart !== 'undefined') {
      renderDonutChart(params.cash, params.ar, params.inv, result.totalCl);
      renderGrowthChart(result.totalCa, result.quickAssets, result.totalCl);
    }
  } catch (err) {
    console.warn('Working Capital Chart rendering error:', err);
  }
}

function renderDonutChart(cash, ar, inv, totalCl) {
  const ctx = document.getElementById('wcDonutChart');
  if (!ctx) return;

  if (wcDonutChart) wcDonutChart.destroy();

  wcDonutChart = new Chart(ctx, {
    type: 'doughnut',
    data: {
      labels: ['Cash & Bank', 'Accounts Receivable', 'Inventory', 'Current Liabilities'],
      datasets: [
        {
          data: [cash, ar, inv, totalCl],
          backgroundColor: [cssVar('--chart-buy'), '#3B82F6', '#F59E0B', cssVar('--chart-rent')],
          borderColor: cssVar('--bg-card'),
          borderWidth: 3,
          hoverOffset: 4,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: { color: cssVar('--chart-tick'), usePointStyle: true, pointStyle: 'circle', padding: 12 },
        },
        tooltip: {
          backgroundColor: cssVar('--tooltip-bg'),
          borderColor: cssVar('--tooltip-border'),
          borderWidth: 1,
          titleColor: cssVar('--tooltip-title'),
          bodyColor: cssVar('--tooltip-body'),
          callbacks: {
            label: (ctx) => `${ctx.label}: ${fmt(ctx.raw)}`,
          },
        },
      },
      cutout: '72%',
    },
  });
}

function renderGrowthChart(totalCa, quickAssets, totalCl) {
  const ctx = document.getElementById('wcGrowthChart');
  if (!ctx) return;

  if (wcGrowthChart) wcGrowthChart.destroy();

  wcGrowthChart = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: ['Liquidity Comparison'],
      datasets: [
        {
          label: 'Total Current Assets',
          data: [totalCa],
          backgroundColor: cssVar('--chart-buy'),
          borderRadius: 6,
        },
        {
          label: 'Quick Assets (Excl Stock)',
          data: [quickAssets],
          backgroundColor: '#3B82F6',
          borderRadius: 6,
        },
        {
          label: 'Total Current Liabilities',
          data: [totalCl],
          backgroundColor: cssVar('--chart-rent'),
          borderRadius: 6,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
          align: 'end',
          labels: { color: cssVar('--chart-tick'), usePointStyle: true, pointStyle: 'circle', padding: 16 },
        },
        tooltip: {
          backgroundColor: cssVar('--tooltip-bg'),
          borderColor: cssVar('--tooltip-border'),
          borderWidth: 1,
          titleColor: cssVar('--tooltip-title'),
          bodyColor: cssVar('--tooltip-body'),
          callbacks: {
            label: (ctx) => `${ctx.dataset.label}: ${fmt(ctx.raw)}`,
          },
        },
      },
      scales: {
        x: {
          grid: { color: cssVar('--chart-grid') },
          ticks: { color: cssVar('--chart-tick') },
        },
        y: {
          grid: { color: cssVar('--chart-grid') },
          ticks: {
            color: cssVar('--chart-tick'),
            callback: (v) => fmtCompact(v),
          },
        },
      },
    },
  });
}

function renderTable(items) {
  const tbody = document.getElementById('wcScheduleBody');
  if (!tbody) return;

  tbody.innerHTML = items.map((row) => {
    const isAsset = row.cat === 'Current Assets';

    return `
      <tr>
        <td style="font-weight: 600;">${row.cat}</td>
        <td>${row.name}</td>
        <td class="${isAsset ? 'advantage-buy' : 'advantage-renter'}">${fmt(row.value)}</td>
        <td>${row.share.toFixed(1)}%</td>
      </tr>
    `;
  }).join('');
}

function exportWcCsv() {
  const params = getWcInputs();
  const result = calculateWc(params);
  const headers = ['Category', 'Balance Sheet Component', 'Amount', 'Share of Category'];
  const rows = result.items.map((r) => [r.cat, r.name, r.value, `${r.share.toFixed(1)}%`]);

  const csv = [headers, ...rows].map((r) => r.join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `working-capital-liquidity-analysis.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}

function applyWcCountryRanges(country, overrideParams = {}) {
  if (!country) return;
  const curr = country.currency || 'USD';

  let defaultCash = 500000;

  if (curr === 'INR') {
    defaultCash = 500000;
  } else if (curr === 'JPY') {
    defaultCash = 5000000;
  }

  const inputs = [
    { id: 'wcCash', val: overrideParams.cash ?? defaultCash },
    { id: 'wcAr', val: overrideParams.ar },
    { id: 'wcInv', val: overrideParams.inv },
    { id: 'wcOtherCa', val: overrideParams.otherCa },
    { id: 'wcAp', val: overrideParams.ap },
    { id: 'wcStLoans', val: overrideParams.stLoans },
    { id: 'wcOtherCl', val: overrideParams.otherCl },
  ];

  inputs.forEach((s) => {
    const el = document.getElementById(s.id);
    if (el && s.val !== null) {
      el.value = s.val;
    }
  });
}

function recalculateWc() {
  const params = getWcInputs();
  updateDisplays(params);
  updateWcUrlParams(params);
  const result = calculateWc(params);
  renderWcResults(result, params);
}

function initWcCalculator() {
  if (!document.getElementById('wcCash')) return;

  const urlParams = parseWcUrlParams();

  initCountry((country) => {
    applyWcCountryRanges(country, urlParams);
    recalculateWc();
  });

  const inputs = ['wcCash', 'wcAr', 'wcInv', 'wcOtherCa', 'wcAp', 'wcStLoans', 'wcOtherCl'];
  inputs.forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', recalculateWc);
      el.addEventListener('change', recalculateWc);
    }
  });

  const exportBtn = document.getElementById('exportWcCsv');
  if (exportBtn) {
    exportBtn.addEventListener('click', exportWcCsv);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initWcCalculator();
});
